let urlModes = {
    isOpportunity: () => $.cdh.helper.urlParam('mode') === 'opportunity',
    removeMode: () => $.cdh.helper.deleteUrlParam('mode')
}

module.exports.PageUrlModes = urlModes;